import { CompensationsActions } from 'src/store/actions/compensationsActions';
import Utils from 'src/utils';
const toOptions = (comments) => comments.map(({ Id, Name }) => ({ label: Name || '', value: Id }));
const initialState = {
    list: [],
    options: [],
    loading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case CompensationsActions.GET_COMPENSATIONS_REQUEST:
        case CompensationsActions.POST_COMPENSATIONS_REQUEST:
        case CompensationsActions.DELETE_COMPENSATIONS_REQUEST: {
            return {
                ...state,
                loading: true
            };
        }
        case CompensationsActions.GET_COMPENSATIONS_SUCCESS: {
            return {
                ...state,
                list: payload,
                options: toOptions(payload),
                loading: false
            };
        }
        case CompensationsActions.POST_COMPENSATIONS_SUCCESS: {
            const compensations = Utils.arrays.mergeWithNestedObjectsReplace(state.list, [payload], 'Id');
            return {
                ...state,
                list: compensations,
                options: toOptions(compensations),
                loading: false
            };
        }
        case CompensationsActions.DELETE_COMPENSATIONS_SUCCESS: {
            const compensations = state.list.filter(({ Id }) => Id !== payload);
            return {
                ...state,
                list: compensations,
                options: toOptions(compensations),
                loading: false
            };
        }
        case CompensationsActions.GET_COMPENSATIONS_FAIL:
        case CompensationsActions.POST_COMPENSATIONS_FAIL:
        case CompensationsActions.DELETE_COMPENSATIONS_FAIL: {
            return {
                ...state,
                loading: false
            };
        }
        default: return state;
    }
};
